export const MENS_CATEGORY = `https://fakestoreapi.com/products/category/men's%20clothing`;

export const WOMENS_CATEGORY = `https://fakestoreapi.com/products/category/women's%20clothing`;

export const JEWELRY_CATEGORY = `https://fakestoreapi.com/products/category/jewelery`;

export const ELECTRONICS_CATEGORY = `https://fakestoreapi.com/products/category/electronics`;

export const SPECIFIC_PRODUCT = `https://fakestoreapi.com/products`;

export const ALL_PRODUCTS = `https://fakestoreapi.com/products`;
